export const APP_NAME = 'Wardell';
export const APP_URL = 'https://wardell.io/';

export const TWITTER_NAME = '@wardell_io';
export const TWITTER_URL = 'https://x.com/wardell_io';

export const REDDIT_NAME = 'u/ahmedkaddoura';
export const REDDIT_URL = 'https://www.reddit.com/user/ahmedkaddoura';
